/*
 * @Author: Merlin
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2024-07-17 11:30:27
 * @Description: 
 */


export const profileCurrenciesResponseState = {
    // ↓ 此处默认值已经改为 0，不然将会调用到默认值，导致不能发觉计算出错，
    btcusdt: 0, // 37793.3,
    usdtbtc: 0, // 0.000026459716404759573,
    ethusdt: 0, // 2040.38,
    usdteth: 0, // 0.0004901047844029054,
    usdtusdt: 0, // 1,
    usdtcny: 0, // 7.09,
    cnyusdt: 0, // 0.14,
};

// ↓ 记录 1 usdt 能换多少其它币 
// ↓ 示例 {usdtcny : 7.14, usdtxxx: 11, ....} 
export const UsdtPrefixCurrencyInitState = Object.fromEntries(
    Object.entries(
        profileCurrenciesResponseState,
    ).filter(aCur => {
        return aCur[0].startsWith('usdt');
    })
);


const UserProfileCurrenciesResponseState = {
    usdt: {
        wager: 68.5,
        wins: 5,
        bets: 37,
    },

    eth: {
        wager: 0.33271232799109135,
        wins: 102,
        bets: 429,
    },

    btc: {
        wager: 0.18908618850549128,
        wins: 342,
        bets: 1281,
    },
};

export const UserProfileResponseState = {
    userStatistic: {
        isBattlesRewardsHidden: false,
        isStakingPayoutsHidden: true,
        isFavoriteGamesHidden: false,
        isProfileDataHidden: false,
        isChatDataHidden: false,
        isGameDataHidden: false,
        totalWagerUsdt: 28302428.791064236,
        levelProgress: 13.2,
        regDate: '2019-11-14T19:39:01.985Z',
        avatar: '',
        level: 14,
        isVip: true,
        isVipTransfer: false,
        name: 'Boomboom',
        _id: '5dcdad554534527ad10e77f6',
        totalBetsCount: 73251,
        totalWinsCount: 60208,
        games: {
            dice: {
                totalBetsInUSD: 24370898.99110996,
                currencies: UserProfileCurrenciesResponseState,
                slots: {
                    totalBetsInUSD: 51382.049370181725,
                    currencies: UserProfileCurrenciesResponseState,
                },
                hilo: {
                    totalBetsInUSD: 0.636141,
                    currencies: UserProfileCurrenciesResponseState,
                },
                stairs: {
                    totalBetsInUSD: 70.5120885,
                    currencies: UserProfileCurrenciesResponseState,
                },
                mines: {
                    totalBetsInUSD: 34.78461,
                    currencies: UserProfileCurrenciesResponseState,
                },
                keno: {
                    totalBetsInUSD: 43205.72113946667,
                    currencies: UserProfileCurrenciesResponseState,
                },
                circle: {
                    totalBetsInUSD: 0.081024,
                    currencies: UserProfileCurrenciesResponseState,
                },
                live: {
                    totalBetsInUSD: 0.10992,
                    currencies: UserProfileCurrenciesResponseState,
                },
                plinko: {
                    totalBetsInUSD: 0.8192299000000001,
                    currencies: UserProfileCurrenciesResponseState,
                },
                table: {
                    totalBetsInUSD: 0.10992,
                    currencies: UserProfileCurrenciesResponseState,
                },
            },
            totalEarnedStakingInUSD: 882.1745223375815,
            totalEarnedCryptoAndBFGStakingInUSD: 882.1745223375815,
        },
    },
    chatStatistic: {
        messagesCount: 0,
        likesCount: 0,
        rainsCount: 0,
        rainsAmountInUSD: 0,
        coinDropsCount: 0,
        coinDropsAmountInUSD: 0,
        statusTitle: 'Junior',
        statusRank: 1,
        messagesCountStatusLimit: 500,
        likesCountStatusLimit: 250,
        rainsCountStatusLimit: 10,
        coinDropsCountStatusLimit: 10,
        maxStatusRank: 5,
        sentTipsAmountInUSD: 0,
        sentTipsCount: 0,
    },
    topGames: [
        {
            totalBetsInUSD: 24370898.99112975,
            name: 'Dice',
            rtp: '99.02%',
            ertp: [],
            rollingAllowed: true,
            image_id: '1',
            category: 'dapps',
            routes: ['inhouse/dice'],
            uuid: '1',
            _id: '5dbe511637d4a30ebf4cabfa',
        },
    ],
    combatStatistic: [],
    winningBattles: [
        {
            eventStarts: '2021-05-30T13:00:00.000Z',
            currency: 'btc',
            award: 0.00336 || { usdt: 6, total: 20, bfg: 880.8754391793259 },
            place: 4,
            name: 'BFG Listing Party Daily',
        },
    ],
};

const oUserInfo = {
    "user": {
        "_id": 70,
        "avatar": '',
        "canWithdraw": false,
        "canWithdrawError": "Not-implemented",
        "cashback": 0,
        "currencies": {
            "cny": {
                "balance": 96310549.9575017,
                "bonusBalance": 0,
                "combatBalance": 0,
                "balanceDelay": 96310549.9575017
            },
            "usdt": {
                "balance": 1251669.39861153,
                "bonusBalance": 0,
                "combatBalance": 0,
                "balanceDelay": 1251669.39861153
            },
            "btc": {
                "balance": 1887.40472429,
                "bonusBalance": 0,
                "combatBalance": 0,
                "balanceDelay": 1887.40472429
            },
            "eth": {
                "balance": 965411.02879728,
                "bonusBalance": 0,
                "combatBalance": 0,
                "balanceDelay": 965411.02879728
            }
        },
        "currentCurrency": "usdt",
        "email": "hellohappystar123@gmail.com",
        "fav": [],
        "isFirstLogin": false,
        "isReferral": false,
        "isVip": 0,
        "lang": "cn",
        "lvl": 1,
        "maxCampaigns": 20,
        "name": "User002x70",
        "notifications": [],
        "promoCheck": true,
        "regDate": "2023-12-27T03:11:02.000Z",
        "timeAlerts": {},
        "tncVersion": "1.0",
        "totalEarnedStaking": 0,
        "totalWager": 0,
        "totalWagerUsdt": 0,
        "two_factor_enabled": false,
        "two_factor_reward": true,
        "vipConfirmShowed": false,
        "vipManager": null,
        "availableTasksCount": 0
    },
    "progress": 0,
    // ↓ 可能存在的错误信息 
    "error": '',
    "code": 0,
}

export type UserInfo = typeof oUserInfo;

export type ProfileCurrenciesResponseState = typeof profileCurrenciesResponseState;

export type UsdtPrefixCurrency = typeof UsdtPrefixCurrencyInitState;

export type UserProfileCurrenciesResponseState = typeof UserProfileResponseState ;
